import angular from 'angular';
import accountSettingsModule from '../accountSettingsModule';

function accountSettingsModalPinCreateController(
  $scope,
  $uibModalInstance,
  accountsService,
  modalData,
  modalConstantsService
) {
  'ngInject';

  angular.extend($scope, modalData);
  $scope.pinInfo = {};
  $scope.pinCreateSuccess = false;

  $scope.pinErrorMessage = function(form) {
    if (
      form.newPin.$error.required ||
      form.newPin.$error.minlength ||
      form.newPinConfirm.$error.required ||
      form.newPinConfirm.$error.minlength
    ) {
      return null;
    }
    if (form.$dirty && form.newPinConfirm.$error.matchField) {
      return modalConstantsService.pinCreate.matchErrorMessage;
    }
    if (form.$pristine && $scope.error) {
      return $scope.error;
    }
    return null;
  };

  $scope.submit = function(form) {
    if (form.$valid) {
      form.$setPristine();
      $scope.error = '';
      accountsService.beginCreateAccountPinSetting($scope.pinInfo.newPin).then(
        function() {
          $scope.pinCreateSuccess = true;
        },
        function(error) {
          $scope.error = accountsService.getPinErrorMessageFromCode(error);
        }
      );
    }
  };

  $scope.dismiss = function() {
    if ($scope.pinCreated) {
      $uibModalInstance.close(true);
    } else {
      $uibModalInstance.dismiss();
    }
  };
}

accountSettingsModule.controller(
  'accountSettingsModalPinCreateController',
  accountSettingsModalPinCreateController
);

export default accountSettingsModalPinCreateController;
